import api from '../../../services/ApiConfig';
import { Apis } from '../../../config';
import { NotificationManager } from 'react-notifications';
import { eraseCookie, setCookie } from '../../../function';

const getClientLogin = async (data) => {
    try {
        const response = await api.post(Apis.GetClientLogin, data, {
            // withCredentials: true,
            headers: { 'Content-Type': 'application/json' }
        });
        let result = JSON.parse(response.data);
        
        
        if (result?.data?.error) {
            NotificationManager.error(result.data.error);
            return null;
        }
        const parsedData=JSON.parse(result.body)
        return parsedData.additionalData;
    } catch (error) {
        console.error('Error in getClientLogin:', error);
        NotificationManager.error('An error occurred while logging in.');
        return null;
    }
};
const authenticate = (data, next) => {
    
    if (typeof window !== "undefined") {
        setCookie('token', data.token, 3000);
        setCookie('role', data.user.userType, 3000);
        setCookie('id', data.user.id, 3000);
        next();
    }
};

const logout = (next) => {
    if (typeof window !== "undefined") {
        eraseCookie('token');
        eraseCookie('role');
        eraseCookie('XSRF-token');
        window.location.reload();
        // Optionally redirect or call next() after logout
        // window.location.href = "/auth/login";
        // next();
    }
};
export default {
    getClientLogin,
    authenticate,
    logout
};